<template>
	<div class="container page">
		<van-nav-bar :title="this.vod_name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="right">
			<van-pull-refresh border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
				<van-grid :column-num="2" :gutter="10">
					<van-grid-item @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
						<van-image class="game_item_img" :src="v.img_url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<span class="rig-name">{{ v.xuanfei_name }}</span>
					</van-grid-item>
				</van-grid>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '北京',
			isLoading: false,
			datalist: [
				// {
				// 	xuanfei_name: '北京 健身达人',
				// 	img_url: 'https://kk.betman2.co/storage/41/62fe1bd26d01c_image_2022-08-18_190032731.png'
				// },
				// {
				// 	xuanfei_name: '北京 学生妹',
				// 	img_url: 'https://kk.betman2.co/storage/344/630869b4bd2d6_1.jpg'
				// }
			]
		};
	},
	methods: {
		back() {
			this.$router.push({ path: 'Choose' });
		},
		onRefresh() {
			setTimeout(() => {
				this.$toast(this.$t('common.refresh'));
				this.isLoading = false;
			}, 500);
		},
		profile(id) {
			this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id });
		},
		getxuanfeilist() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.datalist = res.data;
			});
		}
	},
	created() {
		this.vod_name = this.$route.query.name;
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.right {
	margin-top: 10px;
}
::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	height: auto;
}
::v-deep .van-image__img {
	border-radius: 10px;
	padding: 15px;
}
.rig-name {
	width: 100%;
	height: 60px;
	line-height: 60px;
	margin-top: 10px;
	background-color: #f7f7f7;
	border-radius: 0 0 15px 15px;
	font-size: 15px;
	padding-left: 10px;
}

/* 小屏双列卡片：图片按比例缩放，名称允许多行而不撑破网格 */
@media (max-width: 430px) {
	.page {
		width: 100%;
		max-width: 100vw;
		min-height: 100dvh;
		padding-top: env(safe-area-inset-top);
		padding-bottom: calc(4.75rem + env(safe-area-inset-bottom));
		overflow-x: hidden;
		box-sizing: border-box;
	}

	.page,
	.page * {
		box-sizing: border-box;
	}

	.nav-bar {
		min-height: 3.25rem;
	}

	.nav-bar ::v-deep .van-nav-bar__title {
		min-width: 0;
		padding: 0 .5rem;
		font-size: 1.05rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.right {
		min-width: 0;
		margin-top: .6rem;
		padding: 0 .6rem;
	}

	.list-wrapper,
	::v-deep .van-grid,
	::v-deep .van-grid-item,
	::v-deep .van-grid-item__content {
		min-width: 0;
	}

	::v-deep .van-grid {
		margin: 0 -.3rem;
	}

	::v-deep .van-grid-item {
		padding: .3rem !important;
	}

	::v-deep .van-grid-item__content--center {
		justify-content: flex-start;
		height: 100%;
		padding: 0;
		overflow: hidden;
		border: 1px solid rgba(218, 180, 105, .3);
		border-radius: 1rem;
	}

	.game_item_img {
		display: block;
		width: 100%;
		height: auto;
		aspect-ratio: 3 / 4;
		overflow: hidden;
	}

	::v-deep .game_item_img .van-image__img {
		width: 100%;
		height: 100%;
		padding: 0;
		border-radius: 0;
		object-fit: cover;
	}

	.rig-name {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 3rem;
		height: auto;
		margin-top: 0;
		padding: .55rem .5rem;
		font-size: .85rem;
		line-height: 1.35;
		text-align: center;
		white-space: normal;
		overflow-wrap: anywhere;
	}
}

@media (max-width: 350px) {
	.right {
		padding-right: .4rem;
		padding-left: .4rem;
	}

	::v-deep .van-grid-item {
		padding: .22rem !important;
	}

	.rig-name {
		min-height: 2.8rem;
		padding: .45rem .35rem;
		font-size: .78rem;
	}
}
</style>
